import React from 'react'
import ReactDOM from 'react-dom'
import Root from './Root'
import './global.css'

ReactDOM.render(<Root />, document.getElementById('root'))
